import React from "react";
import { Box } from "@chakra-ui/react";

export function AirplaneIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <Box
        as="path"
        fill="new.yellow.150"
        d="m16.9 140.4 37.7 35.3a32 32 0 0 0 38 4.3L244 92l-18.6-22.8a32 32 0 0 0-41-7.3L140 88 80 68l-16.5 7.1a8 8 0 0 0-2.2 13.3L92 116l-28 16-28-12-16.8 7.2a8 8 0 0 0-2.3 13.2Z"
      />
      <Box
        as="path"
        fill="none"
        stroke="new.yellow.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
        d="M24 216h144M16.9 140.4l37.7 35.3a32 32 0 0 0 38 4.3L244 92l-18.6-22.8a32 32 0 0 0-41-7.3L140 88 80 68l-16.5 7.1a8 8 0 0 0-2.2 13.3L92 116l-28 16-28-12-16.8 7.2a8 8 0 0 0-2.3 13.2Z"
      />
    </Box>
  );
}
